module.exports = __webpack_public_path__ + "./docs/img/big-icon-ref_folder.947292c2ee667a6a9d258a78b9856938.svg";